/**
 * Whether the browser is *certain* it has no connection, as a React value.
 *
 * Only ever used to explain, and to hold back a button that cannot work: `navigator.onLine` is
 * true on a captive portal and on wifi with no route out, so "online" proves nothing and a request
 * still has to be able to fail. "Offline", though, is reliable, which is the direction this is
 * used in.
 */
import { useEffect, useState } from "react";

export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine !== false);
  useEffect(() => {
    const sync = (): void => setOnline(navigator.onLine !== false);
    window.addEventListener("online", sync);
    window.addEventListener("offline", sync);
    return () => {
      window.removeEventListener("online", sync);
      window.removeEventListener("offline", sync);
    };
  }, []);
  return online;
}
